module.exports = __webpack_public_path__ + "static/media/reddit.5322606b.png";